export const FILE_PREVIEW_VIDEO_ICON_PLAY_ID = 'play'
